// extracted by mini-css-extract-plugin
module.exports = {"title":"SettungsInbox_title__19wn6","alert":"SettungsInbox_alert__2yu33"};